import { create } from "zustand"
import { persist } from "zustand/middleware"

interface WidgetSettings {
	weather: boolean
	currencyConverter: boolean
}

interface WidgetStore {
	isEditMode: boolean
	widgetSettings: WidgetSettings
	setEditMode: (isEditMode: boolean) => void
	toggleEditMode: () => void
	updateWidgetSetting: (widget: keyof WidgetSettings, enabled: boolean) => void
	toggleWidget: (widget: keyof WidgetSettings) => void
}

export const useWidgetStore = create<WidgetStore>()(
	persist(
		(set) => ({
			isEditMode: false,
			widgetSettings: {
				weather: true,
				currencyConverter: true
			},
			setEditMode: (isEditMode) => set({ isEditMode }),
			toggleEditMode: () => set((state) => ({ isEditMode: !state.isEditMode })),
			updateWidgetSetting: (widget, enabled) =>
				set((state) => ({
					widgetSettings: {
						...state.widgetSettings,
						[widget]: enabled
					}
				})),
			toggleWidget: (widget) =>
				set((state) => ({
					widgetSettings: {
						...state.widgetSettings,
						[widget]: !state.widgetSettings[widget]
					}
				}))
		}),
		{
			name: "widget-settings",
			partialize: (state) => ({
				widgetSettings: state.widgetSettings
			})
		}
	)
)
